import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import Head from "@/components/Head/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import Vote from "./components/Vote.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, computed, ref, toRefs, reactive } from "vue";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { useStore } from "vuex";
import { SuccessFilled, ArrowRight } from "@element-plus/icons";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  name: "ProblemDetails",
  components: {
    Head: Head,
    Pagination: Pagination,
    SuccessFilled: SuccessFilled,
    ArrowRight: ArrowRight,
    Vote: Vote
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter();
    var id = useRoute().query.id;
    var userId = useStore().state.user.user.userId;
    router.afterEach(function () {
      window.scrollTo(0, 0);
    });
    var transformationTime = computed(function () {
      return function (time) {
        var date = new Date(time);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var h = date.getHours();
        var m = date.getMinutes();
        return year + "/" + month + "/" + date + " " + (h < 10 ? "0".concat(h) : h) + ":" + (m < 10 ? "0".concat(m) : m);
      };
    }); // 图片路径前缀

    var baseUrl = process.env.VUE_APP_BASE_URL;
    var detail = ref({
      status: 0,
      dealList: []
    });
    var switchList = reactive({
      ishide: false,
      show: false
    }); // 记录相关数据

    var cacheData = reactive({
      dealId: 0,
      content: '',
      difficultyId: id,
      satisfied: 0,
      dissatisfied: 0
    }); // 获取预览图片列表

    var previewImgList = computed(function () {
      return function (imgs) {
        var imageList = [];
        var imgList = imgs.split(',');
        imgList.forEach(function (item) {
          imageList.push(baseUrl + item);
        });
        return imageList;
      };
    });
    init();

    function init() {
      getDetail();
    } // 获取数据


    function getDetail() {
      return _getDetail.apply(this, arguments);
    } // 返回


    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, num;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getProblemReportingDetails"]({
                  id: id
                });

              case 2:
                res = _context.sent;

                if (res.code == 0) {
                  detail.value = res.data;
                  num = 0;

                  if (res.data.satisfactionNum) {
                    num += res.data.satisfactionNum;
                  }

                  if (res.data.dissatisfactionNum) {
                    num += res.data.dissatisfactionNum;
                  }

                  if ((res.data.voteFlag || res.data.voteFlag == undefined) && res.data.identity == 2 || res.data.identity != 2) {
                    cacheData.satisfied = Number(res.data.satisfactionNum ? (res.data.satisfactionNum / num * 100).toFixed(2) : 0);
                    cacheData.dissatisfied = Number(res.data.dissatisfactionNum ? (res.data.dissatisfactionNum / num * 100).toFixed(2) : 0);
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getDetail.apply(this, arguments);
    }

    function back() {
      router.back();
    } // 跳转添加步骤


    function toProgress(id, flag) {
      if (detail.value.status != 4) {
        return;
      }

      if (flag) {
        if (!detail.value.dealList || detail.value.dealList.length == 0) {
          ElMessage.warning("请至少填写一次处理过程");
        } else {
          switchList.show = true;
        }
      } else {
        router.push({
          path: "/personal/problemProgress",
          query: {
            id: id,
            isFinishProcess: flag,
            title: "过程描述"
          }
        });
      }
    } // 处理完成


    function confirm() {
      return _confirm.apply(this, arguments);
    } // 点击填写监督


    function _confirm() {
      _confirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["finishProblemReporting"](id);

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  switchList.show = false;
                  init();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _confirm.apply(this, arguments);
    }

    function setSupervision(row) {
      switchList.ishide = true;
      cacheData.dealId = row.dealId;
    } // 提交监督记录


    function submit() {
      return _submit.apply(this, arguments);
    } // 关闭填写监督弹窗


    function _submit() {
      _submit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["insertSupervise"]({
                  content: cacheData.content,
                  difficultyId: cacheData.difficultyId,
                  dealId: cacheData.dealId
                });

              case 2:
                res = _context3.sent;

                if (res.code == 0) {
                  ElMessage.success("提交成功");
                  cacheData.content = "";
                  switchList.ishide = false;
                  getDetail();
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _submit.apply(this, arguments);
    }

    function close() {
      cacheData.content = "";
      cacheData.dealId = 0;
    }

    return _objectSpread(_objectSpread({
      baseUrl: baseUrl,
      userId: userId,
      transformationTime: transformationTime,
      detail: detail,
      cacheData: cacheData,
      previewImgList: previewImgList,
      confirm: confirm,
      init: init,
      close: close
    }, toRefs(switchList)), {}, {
      submit: submit,
      setSupervision: setSupervision,
      toProgress: toProgress,
      back: back
    });
  }
});